import { Navigate, useRoutes } from 'react-router-dom';
import './global.css';
import DashboardLayout from './layouts/dashboard';
import WeekTable from './WeekTable';
import SimpleLayout from './layouts/simple';
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import DashboardAppPage from './pages/DashboardAppPage';
import ResumeDatabase from './pages/ResumeDatabase';
import Worksheet from './pages/Worksheet';
import SalesWorksheet from './pages/SalesWorksheet';
import TrackingSHeet from './pages/TrackingSHeet';
import UserManagement from './pages/UserManagement';
import CompanyManagement from './pages/CompanyManagement';
import RecruiterManagement from './pages/RecruiterManagement';
import SalesManagement from './pages/SalesManagement';
import ResumeDetail from './pages/ResumeDetail';
import RecruiterTeamLead from './pages/RecruiterTeamLead';
import SalesTeamLead from './pages/SalesTeamLead';
import Jobs from './pages/Jobs';
import JobTracker from './pages/JobTracker';
import Clients from './pages/Clients';
import AddJob from './pages/AddJob';
import History from './pages/History';
import SalesDetail from './pages/SalesDetail';
import AddCompany from './pages/addCompany';
import Admins from './pages/admins';
import Management from './pages/Management';
import RecruiterManager from './pages/RecruiterManager';
import SalesManager from './pages/SalesManager';
import SalesTrainee from './pages/Salestrainee';
import Recruitertrainee from './pages/Recruitertrainee';
import JobDetail from './pages/jobDetail';
import ClientDetail from './pages/clientDetail';
import ClientLeads from './pages/ClientLeads';
import Email from './pages/Email';
import MainDashboard from './pages/MainDashboard';
import Signature from './layouts/dashboard/header/Signature';
import MasterData from './pages/MasterData';
import Application from './pages/Applications';

import BenchWorksheet from './pages/BenchWorksheet';
import BenchMang from './pages/BenchManagement';
import BenResumeDetail from './pages/BenchResumeDetails'
// import NotificationsPopover from './layouts/dashboard/header/NotificationsPopover'
import { SignupForm } from './sections/auth/signup';
import Placement from './pages/Placement';
import OpenJobs from './pages/OpenJobs';
import Foxearch from './pages/Foxearch';
import Spam from './pages/Spam';
import Home from './additionalSections/Home';
import AboutUs from './additionalSections/AboutUs';
import ContactUs from './additionalSections/ContactUs';
import Blogs from './additionalSections/Blogs';
import Careers from './additionalSections/Careers';
import ProductDemo from './additionalSections/ProductDemo';
import Trash from './pages/trashData';
import Profile from './pages/Profile';
import UnverifiedEmail from './pages/UnverifiedEmailManagement'; 


import UnverifiedEmailRec from './pages/UnverifiedEmailRec';
import UnverifiedEmailRecHead from './pages/UnverifiedEmailRecHead';
import UnverifiedEmailRecManager from './pages/UnverifiedEmailRecManager';
import UnverifiedEmailRecTeamLead from './pages/UnverifiedEmailRecTeamLead';
import UnverifiedEmailRecTrainee from './pages/UnverifiedEmailRecTrainee';

import UnverifiedEmailSalesExecutive from './pages/UnverifiedEmailSalesExecutive';
import UnverifiedEmailSalesHead from './pages/UnverifiedEmailSalesHead';
import UnverifiedEmailSalesManager from './pages/UnverifiedEmailSalesManager';
import UnverifiedEmailSalesTeamLead from './pages/UnverifiedEmailSalesTeamLead';
import UnverifiedEmailSalesTrainee from './pages/UnverifiedEmailSalesTrainee';
import PlacementTimeLine from './pages/PlacementTimeline';
import DocumentManager  from './pages/DocumentManager';
import ApplyJob from './pages/applyJob';
import ApplyJobPreview from './pages/ApplyJobPreview';
import PaymentHistory from './pages/PaymentHistory';
import JobDetails from './pages/jobDetails';
// ----------------------------------------------------- -----------------

export default function Router() {

  const routes = useRoutes([
    { path: '/login', element: <LoginPage /> },
      { path: 'jobDetails', element: <JobDetails/> },
    { path: 'signup', element: <SignupForm /> },
    {path: "PlacementTimeLine", element:<PlacementTimeLine/>},
    { path: 'home', element: <Home /> },        
    { path: 'aboutUS', element: <AboutUs /> },
    { path: 'contactUs', element: <ContactUs /> },
    {path:"WeekTable/:token", element:<WeekTable/>},
    { path: 'blogs', element: <Blogs /> },
    { path: 'careers', element: <Careers /> },
    { path: 'productDemo', element: <ProductDemo /> }, 
    {path:"/apply-job", element: <ApplyJob/>},
    {path:"/applyJobPreview", element: <ApplyJobPreview/>},
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to="/login" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'user', element: <UserPage /> },
        { path: 'products', element: <ProductsPage /> },
        {path: "Application", element: <Application/>},
        { path: 'blog', element: <BlogPage /> },
        { path: 'resumedatabase', element: <ResumeDatabase /> },
        { path: 'worksheet', element: <Worksheet /> },
        { path: 'benchworksheet', element: <BenchWorksheet /> },
        { path: 'benchmanagement', element: <BenchMang /> },
        { path: 'benchresumedetails', element: <BenResumeDetail /> },
        { path: 'salesworksheet', element: <SalesWorksheet /> },
        { path: 'jobs', element: <Jobs /> },
        { path: 'jobTracker', element: <JobTracker /> },
        { path: 'trackingSheet', element: <TrackingSHeet /> },
        { path: 'clients', element: <Clients /> },
        { path: 'usermanagement', element: <UserManagement /> },
        { path: 'companymanegement', element: <CompanyManagement /> },
        { path: 'Signature', element: <Signature /> },
        { path: 'placement', element: <Placement /> },
        { path: 'openjobs', element: <OpenJobs /> },
        { path: 'foxearch', element: <Foxearch /> },
        { path: 'spam', element: <Spam /> },
        { path: 'trash', element: <Trash /> },
        { path: 'profile', element: <Profile /> },
           {path:'/DocumentManager', element:<DocumentManager/>},
        // { path: 'Notification', element: <NotificationsPopover /> },
        {
          path: 'addjob',
          element: <AddJob />
        },
        { path: 'resumeDetail', element: <ResumeDetail /> },
        { path: 'salesManagement', element: <SalesManagement /> },
        { path: 'recruiterManagement', element: <RecruiterManagement /> },
        { path: 'recruiterTeamLead', element: <RecruiterTeamLead /> },
        { path: 'salesTeamLead', element: <SalesTeamLead /> },
        { path: 'salesDetail', element: <SalesDetail /> },
        { path: 'history', element: <History /> },
        { path: 'addCompany', element: <AddCompany /> },
        { path: 'admins', element: <Admins /> },
        { path: 'management', element: <Management /> },
        { path: 'recuiterManager', element: <RecruiterManager /> },
        { path: 'salesManager', element: <SalesManager /> },
        { path: 'salesTrainee', element: <SalesTrainee /> },
        { path: 'recruitertrainee', element: <Recruitertrainee /> },
        { path: 'jobDetail', element: <JobDetail /> },
        

        { path: "clientDetail", element: <ClientDetail /> },
        { path: "clientLeads", element: <ClientLeads /> },
        { path: "email", element: <Email /> },
        { path: 'mainDashboard', element: <MainDashboard /> },
        { path: 'masterData', element: <MasterData /> },
        { path: 'unverifiedEmailManagement', element: <UnverifiedEmail /> },

        { path: 'unverifiedEmailRec', element: <UnverifiedEmailRec /> },
        { path: 'unverifiedEmailRecHead', element: <UnverifiedEmailRecHead /> },
        { path: 'unverifiedEmailRecManager', element: <UnverifiedEmailRecManager /> },
        { path: 'unverifiedEmailRecTeamLead', element: <UnverifiedEmailRecTeamLead /> },
        { path: 'unverifiedEmailRecTrainee', element: <UnverifiedEmailRecTrainee /> },

        { path: 'unverifiedEmailSalesExecutive', element: <UnverifiedEmailSalesExecutive /> },
        { path: 'unverifiedEmailSalesHead', element: <UnverifiedEmailSalesHead /> },
        { path: 'unverifiedEmailSalesManager', element: <UnverifiedEmailSalesManager /> },
        { path: 'unverifiedEmailSalesTeamLead', element: <UnverifiedEmailSalesTeamLead /> },
        { path: 'unverifiedEmailSalesTrainee', element: <UnverifiedEmailSalesTrainee /> }, 
        
        { path:"payment-history/:placementId/:invoice", element:<PaymentHistory />}

     

      ],
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}













//    <Dialog
//   open={invoiceModalOpen}
//   onClose={() => setInvoiceModalOpen(false)}
//   maxWidth="md"
//   PaperProps={{
//     sx: {
//       border: "3px solid #2f4fa1",   //  OUTER BORDER
//       borderRadius: 2,
//       width: "750px",
//       maxWidth: "95%",
//     },
//   }}
// >
//   {/* HEADER */}
//   <DialogTitle
//     sx={{
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       borderBottom: "2px solid #2f4fa1",
//     }}
//   >
//     Invoice
//     <Button variant="contained" size="small" onClick={handleEditSave}>
//       {isInvoiceEdit ? "Save" : "Edit"}
//     </Button>
//   </DialogTitle>

//   {/* CONTENT */}
//   <DialogContent sx={{ p: 2 }}>
//     {/* INNER INVOICE BORDER */}
//     <Box
//       ref={pdfRef}
//       sx={{
//         border: "2px solid #2f4fa1",
//         borderRadius: 2,
//         p: 4,
//       }}
//     >
//       <Typography align="center" fontWeight={700} mb={3}>
//         INVOICE
//       </Typography>

//       <Box display="flex" justifyContent="space-between">
//         {/* LEFT */}
//         <Box width="60%">
//           {/* FROM */}
//           <Box mb={2}>
//             <Typography fontWeight={600}>From :</Typography>
//             {isInvoiceEdit ? (
//               <TextField
//                 multiline
//                 minRows={2}
//                 size="small"
//                 fullWidth
//                 name="fromAddress"
//                 value={invoiceData.fromAddress}
//                 onChange={handleChange}
//               />
//             ) : (
//               <Typography whiteSpace="pre-line">
//                 {invoiceData.fromAddress}
//               </Typography>
//             )}
//           </Box>

//           {/* BILLED TO */}
//           <Box mb={2}>
//             <Typography fontWeight={600}>Billed To :</Typography>
//             {isInvoiceEdit ? (
//               <TextField
//                 multiline
//                 minRows={2}
//                 size="small"
//                 fullWidth
//                 name="billedTo"
//                 value={invoiceData.billedTo}
//                 onChange={handleChange}
//               />
//             ) : (
//               <Typography whiteSpace="pre-line">
//                 {invoiceData.billedTo}
//               </Typography>
//             )}
//           </Box>

//           {/* ACH DETAILS */}
//           <Box mt={2}>
//             <Typography fontWeight={600} mb={1}>
//               ACH Details:
//             </Typography>

//             {isInvoiceEdit ? (
//               <Stack spacing={1.5}>
//                 {[
//                   ["Account Number", "accountNumber"],
//                   ["Account Type", "accountType"],
//                   ["Routing Number", "routingNumber"],
//                 ].map(([label, name]) => (
//                   <Box key={name} display="flex" alignItems="center" gap={1}>
//                     <Typography sx={{ minWidth: 150 }}>
//                       {label} :
//                     </Typography>
//                     <TextField
//                       size="small"
//                       fullWidth
//                       name={name}
//                       value={invoiceData[name]}
//                       onChange={handleChange}
//                     />
//                   </Box>
//                 ))}

//                 <Box display="flex" alignItems="flex-start" gap={1}>
//                   <Typography sx={{ minWidth: 150, mt: 1 }}>
//                     Bank Details :
//                   </Typography>
//                   <TextField
//                     multiline
//                     minRows={2}
//                     size="small"
//                     fullWidth
//                     name="bankName"
//                     value={invoiceData.bankName}
//                     onChange={handleChange}
//                   />
//                 </Box>

//                 <Box display="flex" alignItems="center" gap={1}>
//                   <Typography sx={{ minWidth: 150 }}>
//                     Beneficiary Name :
//                   </Typography>
//                   <TextField
//                     size="small"
//                     fullWidth
//                     name="beneficiaryName"
//                     value={invoiceData.beneficiaryName}
//                     onChange={handleChange}
//                   />
//                 </Box>
//               </Stack>
//             ) : (
//               <>
//                 <Typography>Account Number : {invoiceData.accountNumber}</Typography>
//                 <Typography>Account Type : {invoiceData.accountType}</Typography>
//                 <Typography>Routing Number : {invoiceData.routingNumber}</Typography>
//                 <Typography>Bank Details : {invoiceData.bankName}</Typography>
//                 <Typography>Beneficiary Name : {invoiceData.beneficiaryName}</Typography>
//               </>
//             )}
//           </Box>
//         </Box>

//         {/* RIGHT */}
//         <Box width="35%">
//           <Typography>Date : {invoiceData.invoiceDate}</Typography>
//           <Typography>Invoice # : {invoiceData.invoiceNumber}</Typography>
//           <Typography>Due Date : {invoiceData.dueDate}</Typography>
//         </Box>
//       </Box>
//     </Box>
//   </DialogContent>
// </Dialog>



















      
//       <Dialog
//   open={invoiceModalOpen}
//   onClose={() => setInvoiceModalOpen(false)}
//   maxWidth="md"
//   PaperProps={{
//     sx: {
//       border: "3px solid #3C6BA5",
//       borderRadius: 2,
//       width: "750px",
//       maxWidth: "95%",
//     },
//   }}
// >
//   {/* HEADER */}
//   <DialogTitle
//     sx={{
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       // borderBottom: "2px solid #3C6BA5",
//     }}
//   >
//     Invoice
//     <Button variant="contained" size="small" onClick={handleEditSave}>
//       {isInvoiceEdit ? "Save" : "Edit"}
//     </Button>
//   </DialogTitle>

//   {/* CONTENT */}
//   <DialogContent sx={{ p: 2 }}>
//     {/* INNER BORDER */}
//     <Box
//       ref={pdfRef}
//       sx={{
//         border: "2px solid #3C6BA5",
//         borderRadius: 2,
//         p: 4,
//       }}
//     >
//       <Typography align="center" fontWeight={700} mb={3}>
//         INVOICE
//       </Typography>

//       {/* TOP SECTION */}
//       <Box display="flex" justifyContent="space-between" gap={2}>
//         {/* LEFT */}
//         <Box width="60%">
//           {/* FROM */}
//           <Box mb={2}>
//             <Typography fontWeight={600}>From :</Typography>
//             {isInvoiceEdit ? (
//               <TextField
//                 multiline
//                 minRows={2}
//                 size="small"
//                 fullWidth
//                 name="fromAddress"
//                 value={invoiceData.fromAddress}
//                 onChange={handleChange}
//               />
//             ) : (
//               <Typography whiteSpace="pre-line">
//                 {invoiceData.fromAddress}
//               </Typography>
//             )}
//           </Box>

//           {/* BILLED TO */}
//           <Box mb={2}>
//             <Typography fontWeight={600}>Billed To :</Typography>
//             {isInvoiceEdit ? (
//               <TextField
//                 multiline
//                 minRows={2}
//                 size="small"
//                 fullWidth
//                 name="billedTo"
//                 value={invoiceData.billedTo}
//                 onChange={handleChange}
//               />
//             ) : (
//               <Typography whiteSpace="pre-line">
//                 {invoiceData.billedTo}
//               </Typography>
//             )}
//           </Box>

//           {/* ACH DETAILS */}
//           <Box mt={2}>
//             <Typography fontWeight={600} mb={1}>
//               ACH Details :
//             </Typography>

//             {isInvoiceEdit ? (
//               <Stack spacing={1.5}>
//                 {[
//                   ["Account Number", "accountNumber"],
//                   ["Account Type", "accountType"],
//                   ["Routing Number", "routingNumber"],
//                 ].map(([label, name]) => (
//                   <Box key={name} display="flex" gap={1} alignItems="center">
//                     <Typography sx={{ minWidth: 150 }}>
//                       {label} :
//                     </Typography>
//                     <TextField
//                       size="small"
//                       fullWidth
//                       name={name}
//                       value={invoiceData[name]}
//                       onChange={handleChange}
//                     />
//                   </Box>
//                 ))}

//                 <Box display="flex" gap={1} alignItems="flex-start">
//                   <Typography sx={{ minWidth: 150, mt: 1 }}>
//                     Bank Details :
//                   </Typography>
//                   <TextField
//                     multiline
//                     minRows={2}
//                     size="small"
//                     fullWidth
//                     name="bankName"
//                     value={invoiceData.bankName}
//                     onChange={handleChange}
//                   />
//                 </Box>

//                 <Box display="flex" gap={1} alignItems="center">
//                   <Typography sx={{ minWidth: 150 }}>
//                     Beneficiary Name :
//                   </Typography>
//                   <TextField
//                     size="small"
//                     fullWidth
//                     name="beneficiaryName"
//                     value={invoiceData.beneficiaryName}
//                     onChange={handleChange}
//                   />
//                 </Box>
//               </Stack>
//             ) : (
//               <>
//                 <Typography>Account Number : {invoiceData.accountNumber}</Typography>
//                 <Typography>Account Type : {invoiceData.accountType}</Typography>
//                 <Typography>Routing Number : {invoiceData.routingNumber}</Typography>
//                 <Typography>Bank Details : {invoiceData.bankName}</Typography>
//                 <Typography>Beneficiary Name : {invoiceData.beneficiaryName}</Typography>
//               </>
//             )}
//           </Box>
//         </Box>

//         {/* RIGHT */}
//         <Box width="35%">
//           {isInvoiceEdit ? (
//             <>
//               <TextField
//                 type="date"
//                 label="Date"
//                 InputLabelProps={{ shrink: true }}
//                 size="small"
//                 fullWidth
//                 name="invoiceDate"
//                 value={invoiceData.invoiceDate}
//                 onChange={handleChange}
//                 sx={{ mb: 2 }}
//               />

//               <TextField
//                 label="Invoice #"
//                 size="small"
//                 fullWidth
//                 name="invoiceNumber"
//                 value={invoiceData.invoiceNumber}
//                 onChange={handleChange}
//                 sx={{ mb: 2 }}
//               />

//               <TextField
//                 type="date"
//                 label="Due Date"
//                 InputLabelProps={{ shrink: true }}
//                 size="small"
//                 fullWidth
//                 name="dueDate"
//                 value={invoiceData.dueDate}
//                 onChange={handleChange}
//               />
//             </>
//           ) : (
//             <>
//               <Typography>Date : {invoiceData.invoiceDate}</Typography>
//               <Typography>Invoice # : {invoiceData.invoiceNumber}</Typography>
//               <Typography>Due Date : {invoiceData.dueDate}</Typography>
//             </>
//           )}
//         </Box>
//       </Box>

//       {/* TABLE */}




//       <Box mt={4}>
//         <Table>
//           <TableHead sx={{borderRadius: "3px solid #3C6BA5",}}>
//             <TableRow sx={{backgroundColor: 'text.secondary' }}>
//                 <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Description</TableCell> 
//                  <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Rate</TableCell>
//                   <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Hours</TableCell>
//                    <TableCell sx={{ p: 1, py: 0.5, color: 'white' }}>Amount</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             <TableRow>
//               <TableCell>
//                 {isInvoiceEdit ? (
//                   <TextField
//                     variant="standard"
//                     fullWidth
//                     name="description"
//                     value={invoiceData.description}
//                     onChange={handleChange}
//                   />
//                 ) : (
//                   invoiceData.description
//                 )}
//               </TableCell>
//               <TableCell>${rate}/hr</TableCell>
//               <TableCell>{totalHours}</TableCell>
//               <TableCell>${rate * fun1(totalHours)}</TableCell>
//             </TableRow>
//           </TableBody>
//         </Table>
//       </Box>

//       {/* TOTAL */}
//       <Box textAlign="right" mt={3}>
//         <Typography>Subtotal : ${rate * fun1(totalHours)}</Typography>
//         <Typography>Tax : $0</Typography>
//         <Typography fontWeight={700}>
//           Total : ${rate * fun1(totalHours)}
//         </Typography>
//       </Box>
//     </Box>
//   </DialogContent>
//        </Dialog>